import { render } from "./IVkBook.vue?vue&type=template&id=75006e46"
import script from "./IVkBook.vue?vue&type=script&lang=js"
export * from "./IVkBook.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__